module.exports = __webpack_public_path__ + "static/img/B (29).47cc8fea.png";